<template>
<div class="modal-card" style="width: 650px">
    <header class="modal-card-head">
        <p class="modal-card-title">Manage Module</p>

    </header>
    <section class="modal-card-body">
        <!--   //////////////////////////////////////////////////////// -->
        <div class="card-content">
            <div class="columns">
                <div class="column">
                    <b-field label="Title">
                        <b-input placeholder="What is amazon FBA ?" v-model="file.title" expanded>
                        </b-input>
                    </b-field>
                </div>
                <div class="column">
                    <b-field label="Priority">
                        <b-input type="number" v-model.number="file.priority" placeholder="1">

                        </b-input>
                    </b-field>
                </div>
            </div>
        </div>
        <!-- /////////////////////////////////////////////// -->
    </section>
    <footer class="modal-card-foot">

        <button class="button is-black full-width-button" style=" width: 100%;  color:white" :class="{'is-loading': isLoading}" @click="manageModule(file)">

            Save</button>
    </footer>
</div>
</template>

<script>
import ChapterService from './service';
import UploadService from '../../lib/UploadService';
/* import GroupService from '../settings/service' */
import Firebase from '../../lib/Firebase';
import Firestore from '../../lib/Firestore';
export default {

    name: 'addModule',
    props: ['propModule'],

    created() {
        /* this.fetchGroups(); */
        if (this.propModule.docId) {
            this.file = {
                ...this.propModule
            };
        }
        console.log(this.file)

    },

    data() {
        return {
            isLoading: false,
            file: {
                title: null,
                priority : null
            },
        };
    },

    methods: {

        manageModule(file) {
            this.isLoading = true;
               file = {
                    updatedAt: new Date(),
                    ...file
                }
                // this.cities.push(file)
                ChapterService.manageModule(file).then(() => {
                    this.isLoading = false;
                    this.$buefy.toast.open("Saved successfully");
                    this.$emit("close");
                });

                this.isLoading = false;
                this.$buefy.toast.open("Saved successfully");
                // this.array.push(videoFile);
                this.$emit("close");


        },
        /*     a(file) {
                this.isLoading = true;

               
            }, */
    },
    /* computed: {
            filteredDataArray() {
          
                 return this.data.filter((option) => {
                     return option
                         .toString()
                         .toLowerCase()
                         .indexOf(this.user.state.toLowerCase()) >= 0
                 })
             },
             filteredDataArraychapter() {
          
                 return this.districts.filter((option) => {
                     return option
                         .toString()
                         .toLowerCase()
                         .indexOf(this.user.chapter.toLowerCase()) >= 0
                 })
             }

         } */
};
</script>

<style>
.zipcode-container {
    display: flex;
    justify-content: space-between;
}

.pan-image {
    height: 270px;
}
</style>



// WEBPACK FOOTER //
// src/pages/course/addModules.vue